exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-332ea54b] {\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n}\n.modal-card-head[data-v-332ea54b] {\n  border-bottom: 1px solid #f2f5f7;\n}\n.modal-card-foot[data-v-332ea54b] {\n  border-top: 0;\n}\n.modal-card-body[data-v-332ea54b] {\n  min-height: 5rem;\n}\nimg[lazy=loading][data-v-332ea54b] {\n  max-height: 4rem;\n  min-height: 4rem;\n}\nimg[lazy=error][data-v-332ea54b] {\n  max-height: unset;\n  min-height: unset;\n  object-fit: contain;\n}\nimg[lazy=loaded][data-v-332ea54b] {\n  max-height: unset;\n  min-height: unset;\n}", ""]);

// exports
